import { useState, useEffect} from "react";
import { useParams} from "react-router";
import PortfolioData from "../../Database/portfolio_projects.json";
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import parse from 'html-react-parser'
import "./index.css";
import { text } from "stream/consumers";
import { faUnderline } from "@fortawesome/free-solid-svg-icons";
import MetaTags from "../../../components/MetaTags";
export default function PortfolioProjects() {
    const PortfolioDataArray = PortfolioData.PortfolioExpData
    const { pid } = useParams();
    const project = PortfolioDataArray.find((portfolio) => portfolio._id === pid)
    let text_project:string;
    text_project = project?._full_description ?? '';
    const moment = require('moment');
    const [isThereGithub, setisThereGithub] =useState(project?._is_github_rep);
    const [isUniqueImg, setisUniqueImg] = useState(project?._is_img_unique);
    const ImgsInfoArray = project?._carousel_data;
    const [isMobile, setIsMobile] = useState(false);
    
    useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth <= 750);
        };

        handleResize(); // Initial check
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);

    }, []);

    function limitText(text:string, maxLength:number) {
      if (text.length > maxLength) {
        return text.substring(0, maxLength);
      }
      return text;
    }
    let text_project_seo:string;
    text_project_seo = project?._small_description_seo ?? '';
    let small_description_seo = limitText(text_project_seo, 170);

    return(
      <>
      <MetaTags 
        title={project?._title}
        description={small_description_seo}
        image={project?._principal_img} />
      
        <div id="wd-portfolio-post" className="pt-0 pb-5 ms-1 me-1">
        <div className="row">
            <div className="col-md-1 col-lg-2"></div>
            <div className="col-md-10 col-lg-8">
                <h1 className="wd-portfolio-title">{project?._title}</h1> <hr/>
                { isThereGithub ? (<div id="wd-authored-row" className="row">
                    <div className="col-4">
                        <div className="ms-0" id="wd-author-by">Author</div>
                        <div className="ms-0" id="wd-author">Alfonso Barajas</div>
                    </div>
                    <div className="col-4">
                        <div className="me-0" id="wd-author-by">END DATE</div>
                         <div className="me-0" >{moment(project?._date).format('MM/YYYY')}</div>
                    </div>
                    <div className="col-4">
                        <div className="me-0" id="wd-author-by">REPOSITORY</div>
                         <div className="me-0"> <a className="wd-github-repo" href={project?._github_rep} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faGithub} size="2x"/></a></div>
                    </div>
                </div>) : ( <div id="wd-authored-row" className="row">
                    <div className="col-6">
                        <div className="ms-0" id="wd-author-by">AUTHORED BY</div>
                        <div className="ms-0" id="wd-author">Alfonso Barajas</div>
                    </div>
                    <div className="col-6">
                        <div className="me-0" id="wd-author-by">END DATE</div>
                         <div className="me-0" >{moment(project?._date).format('MM/YYYY')}</div>
                    </div>
                </div>)}
                <div id="wd-post-content" className="pt-4 pb-4">
                { (isUniqueImg || isMobile) ? (<div id="wd-post-image">
                    <img src={project?._principal_img} className="wd-image-home" />
                </div>) : (
                    <div className="d-flex justify-content-center">
                    <div id="carouselExampleCaptions" className="carousel carousel-dark slide d-flex justify-content-center" data-bs-ride="carousel">
                    <div className="carousel-indicators">
                        {ImgsInfoArray?.map( (_, index) => (
                                <button  
                                key={index}
                                type="button" 
                                data-bs-target="#carouselExampleCaptions" 
                                data-bs-slide-to={index}
                                className={index === 0 ? "active" : ""}
                                aria-current={index === 0 ? "true": undefined}
                                aria-label={`Slide ${index + 1}`}>
                                </button>
                        ))}
                    </div>
                  
                    <div className="carousel-inner d-flex align-items-center center pb-5" style={{width: "400px"}}>

                      {ImgsInfoArray?.map( (slide,index) => (
                        <div    key={index} 
                                className={`carousel-item text-center ${index === 0 ? "active" : ""}`}
                                >
                        <img src={slide.image} className="d-block carousel-img w-100" alt={`Slide ${index+1}`} />
                        <div className="slide-caption-container">
                          <h5 className="text-black">{slide.label}</h5>
                          <p className="text-black">{slide.description}</p>
                        </div>
                      </div>

                      ))}
                

                    </div>
                  
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
                      <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                      <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
                      <span className="carousel-control-next-icon" aria-hidden="true"></span>
                      <span className="visually-hidden">Next</span>
                    </button>
                  </div>

                  </div>
                  
                ) }
                <div id="wd-post-text"  className="text-start pt-4">
                    {parse(text_project)}
                </div>
                </div>
            </div>
            <div className="col-md-1 col-lg-2"></div>
        </div>
    </div>
    </>
    );
}